import ResetPasswordAuth from "modules/auth/ResetPassword";

const ResetPassword = () => {
  return <ResetPasswordAuth />
};

export default ResetPassword;